import { OverlayModule } from '@angular/cdk/overlay';
import { AsyncPipe } from '@angular/common';
import { Component, HostListener, inject, ViewEncapsulation } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { StoPipesModule } from '@ngx-stoui/core';
import { Observable } from 'rxjs';
import { ReleaseNote } from './models';
import { ReleaseNoteDialogComponent } from './release-note-dialog.component';
import { ReleaseNotesService } from './release-notes.service';

@Component({
  selector: 'ct-release-notes',
  template: `
    <button
      (click)="setOpen()"
      style="margin-right: 8px"
      cdkOverlayOrigin
      #trigger="cdkOverlayOrigin"
      mat-icon-button
      [matBadge]="unread$ | async"
      [matBadgeOverlap]="true"
      matBadgeSize="small"
      matBadgePosition="above after"
      [matBadgeHidden]="(unread$ | async) === 0"
    >
      <mat-icon>notifications</mat-icon>
    </button>

    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayHasBackdrop]="true"
      cdkConnectedOverlayBackdropClass="release-notes-backdrop"
      (backdropClick)="close()"
      [cdkConnectedOverlayOpen]="open"
    >
      <div class="mat-elevation-z3 ct-release-notes-list">
        <div class="ct-release-notes-list-item bold">Notifications</div>
        <mat-divider></mat-divider>
        @let notifications = notifications$ | async;
        @for (notification of notifications; track notification) {
          <div
            class="ct-release-notes-list-item"
            style="cursor: pointer"
            [class.read]="notification.read"
            [class.unread]="!notification.read"
            (click)="show(notification)"
          >
            New release -
            <span>{{ notification.date | formatDate }}:</span>
          </div>
          <mat-divider></mat-divider>
        }
        <!--        <div class="ct-release-notes-list-item ct-release-notes-list-footer">
        <button mat-button color="primary">See all notifications</button>
      </div>-->
      </div>
    </ng-template>
  `,
  imports: [
    OverlayModule,
    MatIconModule,
    MatButtonModule,
    AsyncPipe,
    MatBadgeModule,
    MatDividerModule,
    StoPipesModule,
    MatDialogModule,
  ],
  styleUrl: './release-notes.component.scss',
  providers: [ReleaseNotesService],
  encapsulation: ViewEncapsulation.None,
})
export class ReleaseNotesComponent {
  private service = inject(ReleaseNotesService);
  private dialog = inject(MatDialog);
  public notifications$: Observable<Array<ReleaseNote>> = this.service.getFirstFive();
  public unread$ = this.service.getUnreadCounter();
  public open = false;

  setOpen() {
    this.open = !this.open;
  }

  @HostListener('window:keydown.escape')
  close() {
    this.open = false;
    this.service.markAllRead();
  }

  show(data: ReleaseNote) {
    this.close();
    this.dialog.open(ReleaseNoteDialogComponent, {
      data,
      panelClass: 'sto-dialog',
      width: '750px',
    });
  }
}
